/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_AmendmentInputs */

const en_orders_amendment = /** @type {(inputs: Orders_AmendmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amendment`)
};

const es_orders_amendment = /** @type {(inputs: Orders_AmendmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enmienda`)
};

/**
* | output |
* | --- |
* | "Amendment" |
*
* @param {Orders_AmendmentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amendment = /** @type {((inputs?: Orders_AmendmentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_AmendmentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amendment(inputs)
	return es_orders_amendment(inputs)
});